import React from 'react'
import Loading from 'shared/Loading'

import ScanDialog from 'shared/ScanDialog'
import Dashboard, { DashboardCardItem } from 'shared/Dashboard'
import useStyles from 'shared/hooks/useStyle'

import useDirectScan from './useDirectScan'

import styles from './DirectScan.style'

const DirectScan = () => {
    const classes = useStyles(styles)

    const {
        isLoading,
        error,
        openScan,
        openProcesses,
        processesMap,
        onScan,
    } = useDirectScan()

    if (error) {
        throw error
    }

    if (openProcesses && (!processesMap || processesMap.length === 0)) {
        return (
            <span>No available processes</span>
        )
    }

    return (
        <div css={classes.root}>
            <div>
                <ScanDialog
                    open={openScan}
                    onClose={onScan}
                    item={null}
                />
            </div>
            <div css={classes.main}>
                {(openProcesses && (
                    <Dashboard
                        widgets={processesMap}
                        widgetComponent={DashboardCardItem}
                    />
                ))}
            </div>
            { isLoading && (<Loading />)}
        </div>
    )
}

export default DirectScan
